import { ICardForm } from '@/interface';
import { AIGC_VIDEO_PROMPT_LENGTH, AiType, AiVideoType } from '@/interface/aigc';

export const aigcVideoFormCard: ICardForm = {
  key: 'aigcVideo',
  title: 'AI 智能视频',
  fieldsConfig: [
    {
      props: 'type',
      className: 'aigc-video-type',
      notShowLabel: true,
      render: 'radio',
      uiOptions: {
        theme: 'button',
        defaultValue: AiVideoType.IMAGE,
        options: [
          {
            label: '图生视频',
            value: AiVideoType.IMAGE,
          },
          {
            label: '文生视频',
            value: AiVideoType.TEXT,
          },
        ],
      },
    },
    {
      props: 'imageUrl',
      notShowLabel: true,
      render: 'customAigcFrame',
      uiOptions: {
        label: '上传图片',
        required: true,
      },
    },
    {
      props: 'text',
      className: 'aigc-text-prompt',
      notShowLabel: true,
      render: 'textareaImage',
      rules: [],
      uiOptions: {
        autosize: { minRows: 5, maxRows: 5 },
        maxlength: AIGC_VIDEO_PROMPT_LENGTH,
        placeholder: '请输入画面描述关键词，以逗号分割。\n\n如：天气晴朗，漂亮女生，乌黑秀发，明亮的大眼睛，穿着粉丝裙子，开心微笑，在公园散步',
        label: '画面描述',
        required: true,
        polish: true,
        type: AiType.IMAGE,
        showUpload: false,
      },
    },
    {
      props: 'duration',
      label: '视频时长',
      render: 'radio',
      uiOptions: {
        defaultValue: 5,
        options: [
          {
            label: '5s',
            value: 5,
          },
          {
            label: '10s',
            value: 10,
          },
        ],
      },
    },
  ],
};
